import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "../lib/api";
import { qk } from "./keys";
import type { PickerPerson } from "./types";

/** Active people for the pickers (TL/PO, assignment, account link); `assignable` narrows. */
export function usePeopleSearch(q: string, assignable: boolean, enabled = true) {
  return useQuery({
    queryKey: qk.people(q, assignable),
    queryFn: ({ signal }) =>
      api<PickerPerson[]>("/api/people", { signal, query: { q, assignable: assignable ? true : undefined } }),
    enabled,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
